module.exports = __webpack_public_path__ + "img/1724467557952192.f3e6ee60.png";